export const cssPixel = (value: number) => `${value}px`;

export const cssPercentage = (value: number) => `${value}%`;

export const cssRem = (value: number) => `${value}rem`;

export const cssEm = (value: number) => `${value}em`;
